module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Regular.33f150c.woff";